import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/img_29_260520.png")